import { ResumoCategoriaItem } from "core/features/relatorios/conta-com-composicoes/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";

function useResumoPorCategoriaColumns(): PDFTableColumn<ResumoCategoriaItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<ResumoCategoriaItem>[] = [];

    columns.push({
      title: "Categoria",
      flexGrow: 7,
      render: (original) => (
        <View>
          <Text>{original.nome}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Total",
      flexGrow: 1,
      textAlign: "right",

      render: (original) => (
        <View>
          <Text>{formatMoney(original.valor)}</Text>
        </View>
      ),
    });

    return columns;
  }, []);
}

export default useResumoPorCategoriaColumns;
